module.exports = __webpack_public_path__ + "static/media/7plus.4273d9c8.png";